import { render, staticRenderFns } from "./LinkGroupDialog.vue?vue&type=template&id=e45f91a6&scoped=true"
import script from "./LinkGroupDialog.vue?vue&type=script&lang=js"
export * from "./LinkGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./LinkGroupDialog.vue?vue&type=style&index=0&id=e45f91a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45f91a6",
  null
  
)

export default component.exports